//  Copyright (c) 2026 Molly Xue
//  Licensed under the MIT License
async function $ff61dd1a091f4213$export$e733acd7e07c0138(width, height, fps) {
    if (!navigator.mediaDevices?.getUserMedia) throw new Error('Browser API navigator.mediaDevices.getUserMedia is not available');
    const video = document.getElementById('webcam');
    video.width = width;
    video.height = height;
    video.muted = true;
    const stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
            facingMode: 'user',
            width: width,
            height: height,
            frameRate: {
                max: fps
            }
        }
    });
    video.srcObject = stream;
    return new Promise((resolve)=>{
        video.onloadedmetadata = ()=>resolve(video);
    });
}
async function $ff61dd1a091f4213$export$d2b008984942555e(width, height, fps) {
    const video = await $ff61dd1a091f4213$export$e733acd7e07c0138(width, height, fps);
    video.play();
    return video;
}


const $2ca412f2b7fd875e$var$WINDOW_SIZE = 5; // rolling average buffer length
const $2ca412f2b7fd875e$var$SCALE = 1; // scroll sensitivity multiplier
let $2ca412f2b7fd875e$var$control = {
    state: 'idle',
    grabWindowXPosition: 0,
    grabWindowYPosition: 0,
    handGrabXPoistion: 0,
    handGrabYPosition: 0,
    bufX: [],
    bufY: [],
    bufIdx: 0
};
function $2ca412f2b7fd875e$export$8f7e70c35bef16dc(pinch, predictions) {
    if (predictions == undefined || predictions.length == 0) return;
    if (pinch) {
        const ann = predictions[0].annotations;
        const x = ann.indexFinger[3][0];
        const y = ann.indexFinger[3][1];
        if ($2ca412f2b7fd875e$var$control.state != 'pinch') {
            // ── First frame of a new pinch: capture grab anchor ──
            $2ca412f2b7fd875e$var$control.state = 'pinch';
            $2ca412f2b7fd875e$var$control.grabWindowXPosition = window.scrollX;
            $2ca412f2b7fd875e$var$control.grabWindowYPosition = window.scrollY;
            $2ca412f2b7fd875e$var$control.handGrabXPoistion = x;
            $2ca412f2b7fd875e$var$control.handGrabYPosition = y;
            // Pre-fill the buffer so the first average is stable.
            $2ca412f2b7fd875e$var$control.bufX = Array($2ca412f2b7fd875e$var$WINDOW_SIZE).fill(x);
            $2ca412f2b7fd875e$var$control.bufY = Array($2ca412f2b7fd875e$var$WINDOW_SIZE).fill(y);
            $2ca412f2b7fd875e$var$control.bufIdx = 0;
        }
        // ── Rolling average over the last WINDOW_SIZE frames ──
        $2ca412f2b7fd875e$var$control.bufX[$2ca412f2b7fd875e$var$control.bufIdx] = x;
        $2ca412f2b7fd875e$var$control.bufY[$2ca412f2b7fd875e$var$control.bufIdx] = y;
        $2ca412f2b7fd875e$var$control.bufIdx = ($2ca412f2b7fd875e$var$control.bufIdx + 1) % $2ca412f2b7fd875e$var$WINDOW_SIZE;
        const avgX = $2ca412f2b7fd875e$var$control.bufX.reduce((s, v)=>s + v, 0) / $2ca412f2b7fd875e$var$WINDOW_SIZE;
        const avgY = $2ca412f2b7fd875e$var$control.bufY.reduce((s, v)=>s + v, 0) / $2ca412f2b7fd875e$var$WINDOW_SIZE;
        const deltaX = (avgX - $2ca412f2b7fd875e$var$control.handGrabXPoistion) * $2ca412f2b7fd875e$var$SCALE;
        const deltaY = (avgY - $2ca412f2b7fd875e$var$control.handGrabYPosition) * $2ca412f2b7fd875e$var$SCALE;
        window.scrollTo($2ca412f2b7fd875e$var$control.grabWindowXPosition + deltaX, $2ca412f2b7fd875e$var$control.grabWindowYPosition - deltaY);
    } else {
        if ($2ca412f2b7fd875e$var$control.state == 'pinch') console.log('unpinch');
        $2ca412f2b7fd875e$var$control.state = 'idle';
    }
}


// ─────────────────────────────────────────────────────────
//  Maps raw camera coordinates → CSS screen coordinates
//  and moves the #virtual-cursor element.
//
//  Returns { screenX, screenY } so callers (renderVideo.js)
//  can forward the position to other gesture handlers.
// ─────────────────────────────────────────────────────────
const $e02e324ad509ad30$var$cursor = document.getElementById('virtual-cursor');
// Smoothing for the cursor itself (separate from gesture EMA)
let $e02e324ad509ad30$var$smoothCursor = null;
const $e02e324ad509ad30$var$CURSOR_EMA = 0.2; // 0 = frozen, 1 = raw
function $e02e324ad509ad30$export$4d7186f747f2fbe6(handX, handY, videoWidth, videoHeight) {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    // Camera is mirrored (scaleX(-1) in CSS), so flip X
    const x = (1 - handX / videoWidth) * vw;
    const y = handY / videoHeight * vh;
    return $e02e324ad509ad30$var$smoothMove(x, y);
}
function $e02e324ad509ad30$var$smoothMove(targetX, targetY) {
    // Smooth the cursor independently for a fluid feel
    if (!$e02e324ad509ad30$var$smoothCursor) $e02e324ad509ad30$var$smoothCursor = {
        x: targetX,
        y: targetY
    };
    else {
        $e02e324ad509ad30$var$smoothCursor.x = $e02e324ad509ad30$var$CURSOR_EMA * targetX + (1 - $e02e324ad509ad30$var$CURSOR_EMA) * $e02e324ad509ad30$var$smoothCursor.x;
        $e02e324ad509ad30$var$smoothCursor.y = $e02e324ad509ad30$var$CURSOR_EMA * targetY + (1 - $e02e324ad509ad30$var$CURSOR_EMA) * $e02e324ad509ad30$var$smoothCursor.y;
    }
    if ($e02e324ad509ad30$var$cursor) {
        $e02e324ad509ad30$var$cursor.style.left = `${$e02e324ad509ad30$var$smoothCursor.x}px`;
        $e02e324ad509ad30$var$cursor.style.top = `${$e02e324ad509ad30$var$smoothCursor.y}px`;
    }
    return {
        screenX: $e02e324ad509ad30$var$smoothCursor.x,
        screenY: $e02e324ad509ad30$var$smoothCursor.y
    };
}
function $e02e324ad509ad30$export$80f670792c9660c9() {
    if ($e02e324ad509ad30$var$cursor) $e02e324ad509ad30$var$cursor.style.display = 'none';
}
function $e02e324ad509ad30$export$accb8076477aae77() {
    if ($e02e324ad509ad30$var$cursor) $e02e324ad509ad30$var$cursor.style.display = 'block';
}


// ─────────────────────────────────────────────────────────
//  clickByHandGesture.js  –  fist → open palm = click
// ─────────────────────────────────────────────────────────
let $10cf7727b597bd4a$var$clickControl = {
    state: 'idle',
    lastGestureTime: 0,
    fistAverage: {
        x: 0,
        y: 0
    },
    smoothAvg: null
};
const $10cf7727b597bd4a$var$EMA_ALPHA = 0.35; // smoothing factor for centroid
const $10cf7727b597bd4a$var$FIST_STABLE_MS = 180; // ms fist must be held before arming
const $10cf7727b597bd4a$var$MOVEMENT_STABLE_PX = 14; // px – max drift allowed while arming
const $10cf7727b597bd4a$var$COOLDOWN_MS = 800; // ms between successive clicks
// ── Fist thresholds ───────────────────────────────────────
// A fist = all four fingertips curled close to their MCP (knuckle) joints.
// We measure each fingertip→ MCP distance; if ALL are below FIST_TIP_MCP_MAX
// the hand is considered a fist.
const $10cf7727b597bd4a$var$FIST_TIP_MCP_MAX = 50; // px – tip must be within this of its MCP
const $10cf7727b597bd4a$var$FIST_MIN_FINGERS = 4; // how many fingers must satisfy the above (thumb excluded)
// ── Open-palm threshold ───────────────────────────────────
// Open palm = fingertips spread far from the palm centre.
// We reuse the same spread metric as before.
const $10cf7727b597bd4a$var$OPEN_DISTANCE_THRESHOLD = 110; // px – max spread from centroid
const $10cf7727b597bd4a$var$NEUTRAL_GRACE_MS = 400; // ms of neutral pose before disarming
let $10cf7727b597bd4a$var$neutralSince = 0;
// ─────────────────────────────────────────────────────────
//  Helpers
// ─────────────────────────────────────────────────────────
/**
 * Returns true when the four fingers (index→pinky) are curled into a fist.
 * Strategy: each fingertip should be close to BOTH its MCP knuckle AND the palm base.
 *
 * Handpose annotation indices used:
 *   [0] = MCP (knuckle),  [3] = fingertip
 */ function $10cf7727b597bd4a$var$isFist(annotations) {
    const palmBase = annotations.palmBase[0];
    const PALM_BASE_MAX = 120; // px – tip must also be within this of the palm base
    const fingers = [
        {
            mcp: annotations.indexFinger[0],
            tip: annotations.indexFinger[3]
        },
        {
            mcp: annotations.middleFinger[0],
            tip: annotations.middleFinger[3]
        },
        {
            mcp: annotations.ringFinger[0],
            tip: annotations.ringFinger[3]
        },
        {
            mcp: annotations.pinky[0],
            tip: annotations.pinky[3]
        }
    ];
    let curledCount = 0;
    for (const { mcp: mcp, tip: tip } of fingers){
        const distMCP = Math.hypot(tip[0] - mcp[0], tip[1] - mcp[1]);
        const distPalm = Math.hypot(tip[0] - palmBase[0], tip[1] - palmBase[1]);
        if (distMCP < $10cf7727b597bd4a$var$FIST_TIP_MCP_MAX && distPalm < PALM_BASE_MAX) curledCount++;
    }
    return curledCount >= $10cf7727b597bd4a$var$FIST_MIN_FINGERS;
}
/**
 * Returns true when the hand is open (fingertips spread away from centroid).
 */ function $10cf7727b597bd4a$var$isOpenPalm(annotations) {
    const tips = [
        annotations.thumb[3],
        annotations.indexFinger[3],
        annotations.middleFinger[3],
        annotations.ringFinger[3],
        annotations.pinky[3]
    ];
    const avgX = tips.reduce((s, p)=>s + p[0], 0) / 5;
    const avgY = tips.reduce((s, p)=>s + p[1], 0) / 5;
    let maxDist = 0;
    for (const tip of tips){
        const d = Math.hypot(tip[0] - avgX, tip[1] - avgY);
        if (d > maxDist) maxDist = d;
    }
    return maxDist > $10cf7727b597bd4a$var$OPEN_DISTANCE_THRESHOLD;
}
function $10cf7727b597bd4a$export$388ce54039214433(prediction) {
    const now = Date.now();
    const ann = prediction.annotations;
    // ── Smooth the wrist position for stability checks ────
    const wrist = prediction.landmarks[0]; // [x, y, z]
    if (!$10cf7727b597bd4a$var$clickControl.smoothAvg) $10cf7727b597bd4a$var$clickControl.smoothAvg = {
        x: wrist[0],
        y: wrist[1]
    };
    else {
        $10cf7727b597bd4a$var$clickControl.smoothAvg.x = $10cf7727b597bd4a$var$EMA_ALPHA * wrist[0] + (1 - $10cf7727b597bd4a$var$EMA_ALPHA) * $10cf7727b597bd4a$var$clickControl.smoothAvg.x;
        $10cf7727b597bd4a$var$clickControl.smoothAvg.y = $10cf7727b597bd4a$var$EMA_ALPHA * wrist[1] + (1 - $10cf7727b597bd4a$var$EMA_ALPHA) * $10cf7727b597bd4a$var$clickControl.smoothAvg.y;
    }
    const movement = Math.hypot($10cf7727b597bd4a$var$clickControl.smoothAvg.x - $10cf7727b597bd4a$var$clickControl.fistAverage.x, $10cf7727b597bd4a$var$clickControl.smoothAvg.y - $10cf7727b597bd4a$var$clickControl.fistAverage.y);
    const stable = movement < $10cf7727b597bd4a$var$MOVEMENT_STABLE_PX;
    $10cf7727b597bd4a$var$clickControl.fistAverage = {
        x: $10cf7727b597bd4a$var$clickControl.smoothAvg.x,
        y: $10cf7727b597bd4a$var$clickControl.smoothAvg.y
    };
    // ── Gesture detection ─────────────────────────────────
    const fistDetected = $10cf7727b597bd4a$var$isFist(ann);
    const openPalmDetected = $10cf7727b597bd4a$var$isOpenPalm(ann);
    // ── Visual cursor feedback (driven by STATE, not raw detection) ─────
    const cursor = document.getElementById('virtual-cursor');
    if (cursor) {
        if (fistDetected) {
            cursor.classList.add('cluster'); // red = fist armed
            cursor.classList.remove('open');
        } else {
            cursor.classList.add('open'); // purple = relaxed / open
            cursor.classList.remove('cluster');
        }
    }
    // ── State machine ─────────────────────────────────────
    switch($10cf7727b597bd4a$var$clickControl.state){
        // Waiting for a fist
        case 'idle':
            if (fistDetected && stable) {
                $10cf7727b597bd4a$var$clickControl.state = 'fist';
                $10cf7727b597bd4a$var$clickControl.lastGestureTime = now;
            }
            break;
        // Holding fist – confirm it's intentional, not accidental
        case 'fist':
            if (!fistDetected) {
                $10cf7727b597bd4a$var$clickControl.state = 'idle'; // opened too soon – abort
                break;
            }
            if (!stable) {
                $10cf7727b597bd4a$var$clickControl.lastGestureTime = now; // drifting – restart hold timer
                break;
            }
            if (now - $10cf7727b597bd4a$var$clickControl.lastGestureTime > $10cf7727b597bd4a$var$FIST_STABLE_MS) {
                $10cf7727b597bd4a$var$clickControl.state = 'waitingOpen';
                console.log("[gesture] Fist armed \u2013 open palm to click");
            }
            break;
        // Fist is armed – wait for open palm to fire click
        case 'waitingOpen':
            if (openPalmDetected) {
                console.log("[gesture] CLICK TRIGGERED \u2713");
                $10cf7727b597bd4a$var$fireClick();
                $10cf7727b597bd4a$var$neutralSince = 0;
                $10cf7727b597bd4a$var$clickControl.state = 'clicked';
                break;
            }
            // Hand is in neutral (neither fist nor open) — give it NEUTRAL_GRACE_MS
            // to finish opening before disarming, so the transition doesn't abort early.
            if (!fistDetected && !openPalmDetected) {
                if ($10cf7727b597bd4a$var$neutralSince === 0) $10cf7727b597bd4a$var$neutralSince = now;
                if (now - $10cf7727b597bd4a$var$neutralSince > $10cf7727b597bd4a$var$NEUTRAL_GRACE_MS) {
                    $10cf7727b597bd4a$var$clickControl.state = 'idle';
                    $10cf7727b597bd4a$var$neutralSince = 0;
                }
            } else $10cf7727b597bd4a$var$neutralSince = 0; // still moving toward open — keep waiting
            break;
        // Debounce – wait for neutral pose before allowing next click
        case 'clicked':
            if (!fistDetected && !openPalmDetected) $10cf7727b597bd4a$var$clickControl.state = 'idle';
            break;
    }
}
// ─────────────────────────────────────────────────────────
//  "Open Google" button listener
// ─────────────────────────────────────────────────────────
const $10cf7727b597bd4a$var$openUrl = 'https://www.google.com';
// ─────────────────────────────────────────────────────────
//  Fire click directly on #open-google, regardless of where
//  the hand / cursor currently is on screen.
// ─────────────────────────────────────────────────────────
function $10cf7727b597bd4a$var$fireClick() {
    const btn = document.getElementById('open-google');
    const cursor = document.getElementById('virtual-cursor');
    // ── Apply feedback immediately so the browser paints it ──
    // virtual-hover must be added BEFORE window.open() is called,
    // otherwise focus shifts to the new tab before the frame renders.
    if (btn) {
        btn.classList.add('virtual-hover');
        // Force a reflow so the class is painted this frame
        btn.offsetWidth;
        setTimeout(()=>btn.classList.remove('virtual-hover'), 2000);
    }
    if (cursor) {
        cursor.classList.remove('cluster', 'open');
        cursor.classList.add('fired');
        setTimeout(()=>cursor.classList.remove('fired'), 2000);
    }
    // Open the tab after a short delay so the feedback frame is visible first
    const tab = window.open($10cf7727b597bd4a$var$openUrl, '_blank', 'noopener,noreferrer');
    if (tab) tab.focus();
}


// ─────────────────────────────────────────────────────────
//  gestureForModal.js
//
//  Gesture 1 – "pinch-hold" (middleFinger + thumb ≤ threshold for
//               PINCH_HOLD_MS) → toggles the image modal.
//
//  Gesture 2 – pinkyFinger fingertip hovering over #myImg (in the
//               page, NOT the modal) → shows an overlay
//               caption; moving away hides it.
// ─────────────────────────────────────────────────────────
// ── Tuneable constants ────────────────────────────────────
const $23b79d0787e2d01d$var$PINCH_THRESHOLD = 38; // px – middleFinger-tip to thumb-tip
const $23b79d0787e2d01d$var$PINCH_HOLD_MS = 420; // ms – must hold before firing
const $23b79d0787e2d01d$var$MODAL_COOLDOWN_MS = 900; // ms – debounce between toggles
// ── State ─────────────────────────────────────────────────
let $23b79d0787e2d01d$var$pinchState = {
    active: false,
    startTime: 0,
    fired: false
};
let $23b79d0787e2d01d$var$lastModalToggleTime = 0;
let $23b79d0787e2d01d$var$modalOpen = false;
// ── DOM refs (resolved lazily so the module can be imported early) ──
function $23b79d0787e2d01d$var$getModal() {
    return document.getElementById('myModal');
}
function $23b79d0787e2d01d$var$getCaption() {
    return document.getElementById('caption');
}
function $23b79d0787e2d01d$var$getModalImg() {
    return document.querySelector('.modal-content');
}
function $23b79d0787e2d01d$var$getThumbImg() {
    return document.getElementById('myImg');
}
// ── Ensure the image-hover overlay exists ────────────────
function $23b79d0787e2d01d$var$ensureHoverOverlay() {
    let ov = document.getElementById('gesture-img-overlay');
    if (!ov) {
        ov = document.createElement('div');
        ov.id = 'gesture-img-overlay';
        ov.textContent = "Pinch & hold to open \uD83E\uDD0C ";
        // Inline styles so no extra CSS file is needed (merged into styles.css below)
        Object.assign(ov.style, {
            position: 'absolute',
            bottom: '0',
            left: '0',
            right: '0',
            background: 'linear-gradient(transparent, rgba(0,0,0,0.75))',
            color: '#fff',
            padding: '18px 14px 14px',
            fontSize: 'clamp(0.75rem, 2vw, 1rem)',
            borderRadius: '0 0 10px 10px',
            textAlign: 'center',
            opacity: '0',
            transition: 'opacity 0.25s ease',
            pointerEvents: 'none'
        });
        // The image-container must be position:relative for absolute children
        const container = document.querySelector('.image-container');
        if (container) {
            container.style.position = 'relative';
            container.appendChild(ov);
        }
    }
    return ov;
}
// ── Cursor helper ─────────────────────────────────────────
function $23b79d0787e2d01d$var$setCursorPinching(progress) {
    const cursor = document.getElementById('virtual-cursor');
    if (!cursor) return;
    cursor.style.setProperty('--pinch-progress', progress.toFixed(2));
    cursor.classList.add('pinching');
}
function $23b79d0787e2d01d$var$clearCursorPinching() {
    const cursor = document.getElementById('virtual-cursor');
    if (!cursor) return;
    cursor.classList.remove('pinching');
    cursor.style.setProperty('--pinch-progress', '0');
}
function $23b79d0787e2d01d$export$fc5bd87f75231418(prediction, screenX, screenY) {
    const now = Date.now();
    const ann = prediction.annotations;
    // ── Fingertip positions (raw, camera space) ───────────
    const pinkyTip = ann.pinky[3];
    const thumbTip = ann.thumb[3];
    const pinchDist = Math.hypot(pinkyTip[0] - thumbTip[0], pinkyTip[1] - thumbTip[1]);
    const isPinching = pinchDist <= $23b79d0787e2d01d$var$PINCH_THRESHOLD;
    // ── 1. PINCH-HOLD → toggle modal ─────────────────────
    if (isPinching) {
        if (!$23b79d0787e2d01d$var$pinchState.active) {
            $23b79d0787e2d01d$var$pinchState.active = true;
            $23b79d0787e2d01d$var$pinchState.startTime = now;
            $23b79d0787e2d01d$var$pinchState.fired = false;
        }
        const held = now - $23b79d0787e2d01d$var$pinchState.startTime;
        const progress = Math.min(held / $23b79d0787e2d01d$var$PINCH_HOLD_MS, 1);
        $23b79d0787e2d01d$var$setCursorPinching(progress); // cursor fills yellow as charge builds
        if (!$23b79d0787e2d01d$var$pinchState.fired && held >= $23b79d0787e2d01d$var$PINCH_HOLD_MS) {
            if (now - $23b79d0787e2d01d$var$lastModalToggleTime > $23b79d0787e2d01d$var$MODAL_COOLDOWN_MS) {
                $23b79d0787e2d01d$var$toggleModal();
                $23b79d0787e2d01d$var$lastModalToggleTime = now;
            }
            $23b79d0787e2d01d$var$pinchState.fired = true;
        }
    } else {
        // Released – clean up
        $23b79d0787e2d01d$var$pinchState.active = false;
        $23b79d0787e2d01d$var$pinchState.fired = false;
        $23b79d0787e2d01d$var$clearCursorPinching();
    }
    // ── 2. INDEX HOVER → image caption overlay ───────────
    const overlay = $23b79d0787e2d01d$var$ensureHoverOverlay();
    const thumbImgEl = $23b79d0787e2d01d$var$getThumbImg();
    if (thumbImgEl && overlay && !$23b79d0787e2d01d$var$modalOpen) {
        const rect = thumbImgEl.getBoundingClientRect();
        const inside = screenX >= rect.left && screenX <= rect.right && screenY >= rect.top && screenY <= rect.bottom;
        overlay.style.opacity = inside ? '1' : '0';
    }
}
// ─────────────────────────────────────────────────────────
//  Modal helpers
// ─────────────────────────────────────────────────────────
function $23b79d0787e2d01d$var$toggleModal() {
    const modal = $23b79d0787e2d01d$var$getModal();
    const srcImg = $23b79d0787e2d01d$var$getThumbImg();
    const modalImg = $23b79d0787e2d01d$var$getModalImg();
    if (!modal) return;
    if (!$23b79d0787e2d01d$var$modalOpen) {
        // Populate and open
        if (modalImg && srcImg) modalImg.src = srcImg.src;
        /*     if (caption && srcImg) caption.innerHTML = srcImg.alt; */ modal.style.display = 'block';
        $23b79d0787e2d01d$var$modalOpen = true;
        console.log('[gesture] Modal OPENED');
    } else {
        modal.style.display = 'none';
        $23b79d0787e2d01d$var$modalOpen = false;
        console.log('[gesture] Modal CLOSED');
    }
}
// Also wire up the existing close-button & outside-click behaviour
document.addEventListener('DOMContentLoaded', ()=>{
    const modal = $23b79d0787e2d01d$var$getModal();
    if (!modal) return;
    // Close button (×)
    modal.querySelector('.close')?.addEventListener('click', ()=>{
        modal.style.display = 'none';
        $23b79d0787e2d01d$var$modalOpen = false;
    });
    // Click outside image
    modal.addEventListener('click', (e)=>{
        if (e.target === modal) {
            modal.style.display = 'none';
            $23b79d0787e2d01d$var$modalOpen = false;
        }
    });
    // Thumbnail click (mouse / touch fallback)
    $23b79d0787e2d01d$var$getThumbImg()?.addEventListener('click', ()=>{
        if (!$23b79d0787e2d01d$var$modalOpen) $23b79d0787e2d01d$var$toggleModal();
    });
});


// ── Device-aware video config ─────────────────────────────
function $b03d18f5ace6c282$var$getVideoConfig() {
    const isLowEnd = navigator.hardwareConcurrency <= 4;
    const isMobile = window.innerWidth < 768;
    return {
        width: isMobile ? Math.min(window.innerWidth, 640) : window.innerWidth,
        height: isMobile ? Math.min(window.innerHeight, 480) : window.innerHeight,
        fps: isLowEnd || isMobile ? 20 : 30
    };
}
// ── Helpers ───────────────────────────────────────────────
/**
 * True when a finger is extended (tip is further from the wrist
 * than its MCP knuckle, scaled by EXTENSION_RATIO), because the thumb MCP sits close to the wrist and
 * gives a near-zero distance.
 */ function $b03d18f5ace6c282$var$isFingerExtended(tip, mcp, wrist) {
    const distTip = Math.hypot(tip[0] - wrist[0], tip[1] - wrist[1]);
    const distMcp = Math.hypot(mcp[0] - wrist[0], mcp[1] - wrist[1]);
    return distTip > distMcp * 1.1;
}
/**
 * True when all five digits are extended (open palm).
 * Uses the wrist landmark (index 0) as the common origin.
 */ function $b03d18f5ace6c282$var$fiveFingersExtended(ann) {
    const wrist = ann.palmBase[0]; // palmBase[0] === wrist in handpose
    const fingers = [
        {
            tip: ann.thumb[3],
            mcp: ann.indexFinger[0]
        },
        {
            tip: ann.indexFinger[3],
            mcp: ann.indexFinger[0]
        },
        {
            tip: ann.middleFinger[3],
            mcp: ann.middleFinger[0]
        },
        {
            tip: ann.ringFinger[3],
            mcp: ann.ringFinger[0]
        },
        {
            tip: ann.pinky[3],
            mcp: ann.pinky[0]
        }
    ];
    const extendedCount = fingers.filter(({ tip: tip, mcp: mcp })=>$b03d18f5ace6c282$var$isFingerExtended(tip, mcp, wrist)).length;
    const siFiveFingersExtended = extendedCount >= 5;
    console.log(`Extended fingers: ${extendedCount} \u{2192} ${siFiveFingersExtended ? 'click gesture possible' : 'not click gesture'}`);
    return siFiveFingersExtended;
}
/** Index-to-thumb distance in raw camera space. */ function $b03d18f5ace6c282$var$indexThumbDist(ann) {
    return Math.hypot(ann.indexFinger[3][0] - ann.thumb[3][0], ann.indexFinger[3][1] - ann.thumb[3][1]);
}
async function $b03d18f5ace6c282$var$startDetectionLoop(model, video, videoWidth, videoHeight) {
    async function runDetection() {
        // Draw hand landmarks
        const predictions = await model.estimateHands(video);
        if (predictions !== null && predictions.length > 0) {
            const prediction = predictions[0];
            const ann = prediction.annotations;
            const indexFingerTipX = ann.indexFinger[3][0];
            const indexFingerTipY = ann.indexFinger[3][1];
            // ── Cursor ───────────────────────────────────────────
            // ──  always follows index fingertip ──────────
            const { screenX: screenX, screenY: screenY } = (0, $e02e324ad509ad30$export$4d7186f747f2fbe6)(indexFingerTipX, indexFingerTipY, videoWidth, videoHeight);
            (0, $e02e324ad509ad30$export$accb8076477aae77)();
            const allFingersExtended = $b03d18f5ace6c282$var$fiveFingersExtended(ann);
            const pinchDist = $b03d18f5ace6c282$var$indexThumbDist(ann);
            const treshold = 20;
            let scrollPinchActive = pinchDist <= treshold;
            // ── Priority chain ─────────────────────────────────
            if (allFingersExtended) {
                console.log('all tips visible: click gesture branch');
                // Branch A – 5 tips → fist-to-click gesture
                // (scroll is mutually exclusive: a closed fist hides some tips)
                (0, $10cf7727b597bd4a$export$388ce54039214433)(prediction);
                (0, $2ca412f2b7fd875e$export$8f7e70c35bef16dc)(false, predictions); // ensure scroll is off
            } else if (scrollPinchActive) {
                console.log('scroll pinch active: scroll gesture branch');
                // Branch B – index+thumb pinch → scroll
                (0, $2ca412f2b7fd875e$export$8f7e70c35bef16dc)(true, predictions);
            } else {
                console.log('default branch: no pinch, maybe modal gesture + image hover');
                // Branch C – check pinky+thumb modal gesture + image hover
                (0, $2ca412f2b7fd875e$export$8f7e70c35bef16dc)(false, predictions);
                if (!isNaN(screenX) && !isNaN(screenY)) (0, $23b79d0787e2d01d$export$fc5bd87f75231418)(prediction, screenX, screenY);
            }
        /*  // ── Scroll ───────────────────────────────────────────
      handleScrollByGesture(scrollPinchActive, predictions);

      // ── Click gesture (five-finger cluster → open palm) ──
      if (!pinch) {
        detectFistToOpenPalmClickGesture(prediction);
      }

      // ── Modal gesture (pinch-hold) + image hover overlay ─
      if (screenX && screenY && !isNaN(screenX) && !isNaN(screenY)) {
        detectModalGestures(prediction, screenX, screenY);
      } */ } else {
            // No hand detected — hide cursor, reset scroll state.
            (0, $e02e324ad509ad30$export$80f670792c9660c9)();
            (0, $2ca412f2b7fd875e$export$8f7e70c35bef16dc)(false, []);
        }
        requestAnimationFrame(runDetection);
    }
    //model = await handpose.load();
    runDetection();
}
// ── Bootstrap ─────────────────────────────────────────────
async function $b03d18f5ace6c282$var$main() {
    const cfg = $b03d18f5ace6c282$var$getVideoConfig();
    const video = await (0, $ff61dd1a091f4213$export$d2b008984942555e)(cfg.width, cfg.height, cfg.fps);
    // Dimensions are definitely available here
    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;
    // Load model AFTER video is ready, then kick off the loop
    const model = await handpose.load();
    $b03d18f5ace6c282$var$startDetectionLoop(model, video, videoWidth, videoHeight);
}
$b03d18f5ace6c282$var$main();


//# sourceMappingURL=handgesturewebapp.a2640590.js.map
